module.exports = __webpack_public_path__ + "static/img/ikonaFilm-OFF.1249f322.png";